// extracted by mini-css-extract-plugin
module.exports = {"lockedChatWrapper":"DesktopBroadcastLockedChat__lockedChatWrapper__1lyVo","unavailableMsg":"DesktopBroadcastLockedChat__unavailableMsg__1ABDJ"};